import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import cssText from "./XoSoTruyenThongV3Dark.shadow.css";
import {
  LOTTERIES,
  MB_ROWS,
  SOUTH_HOME,
  SOUTH_PROVINCE,
  fmtGroup,
  lotoCaption,
  lotoOf,
  provinceCaption,
  regionCaption,
  summaryTitle,
  zipStations,
} from "../XoSoTruyenThongV3Light/data";
import useTruyenThongV3, { vnToday } from "../XoSoTruyenThongV3Light/useTruyenThongV3";

const HOST_STYLE = {
  all: "initial",
  display: "block",
  width: "100%",
  maxWidth: "100%",
  margin: 0,
  padding: 0,
  border: 0,
  background: "transparent",
  boxSizing: "border-box",
  lineHeight: "normal",
  color: "#000",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: "14px",
};

const WEEKDAYS = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];

function pad(value) {
  return String(value).padStart(2, "0");
}

function formatDate(date) {
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}

function sameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

function monthCells(year, month) {
  const first = new Date(year, month, 1).getDay();
  const lead = (first + 6) % 7;
  const count = new Date(year, month + 1, 0).getDate();
  const cells = Array.from({ length: lead }, () => null);
  for (let day = 1; day <= count; day += 1) cells.push(day);
  while (cells.length % 7) cells.push(null);
  return cells;
}

function Painted({ value, mode, digit }) {
  const full = String(value);
  const length = mode === "2" ? 2 : mode === "3" ? 3 : full.length;
  const shown = full.slice(-length);
  if (!digit) return shown;
  const tailStart = Math.max(0, shown.length - 2);
  return [...shown].map((char, index) => {
    if (index >= tailStart && char === digit) {
      return (
        <b className="highlight-loto" key={`${char}-${index}`}>
          {char}
        </b>
      );
    }
    return char;
  });
}

function NumberGrid({ values, prize, quantity, mode, digit, className, trail = false }) {
  return (
    <div className={className || "quantity-of-number"} data-quantity={quantity}>
      {values.map((value, index) => (
        <span className="number" data-prize={prize} data-value={value} key={`${value}-${index}`}>
          <Painted value={value} mode={mode} digit={digit} />
          {index < values.length - 1 || trail ? <i className="number-dot"> . </i> : null}
        </span>
      ))}
    </div>
  );
}

function chunk(list, size) {
  const rows = [];
  for (let index = 0; index < list.length; index += size) rows.push(list.slice(index, index + size));
  return rows;
}

function Summary({ title, stations, variant }) {
  const [open, setOpen] = useState(false);

  const preview = stations.map((item, index) => {
    const db = item.prizes.db[0];
    const tail = String(db).slice(-2);
    const g1 = item.prizes.g1[0];
    const sep = index < stations.length - 1 ? " — " : "";
    if (variant === "mb") {
      return (
        <span key={item.key}>
          Miền Bắc: Giải Đặc biệt: <strong>{db}</strong> (2 số cuối: <strong>{tail}</strong>) | Giải Nhất: <strong>{g1}</strong> | Giải Bảy: <strong>{item.prizes.g7.join(" - ")}</strong>
        </span>
      );
    }
    return (
      <span key={item.key}>
        {item.name}: G.ĐB: <strong>{db}</strong> (2 số cuối: <strong>{tail}</strong>) | G1: <strong>{g1}</strong>
        {sep}
      </span>
    );
  });

  return (
    <div className={`lottery-summary-box lottery-summary-text${open ? " is-expanded" : " is-collapsed"}`}>
      <div className="lottery-summary-heading-row">
        <strong className="lottery-summary-title">{title}</strong>
        <button type="button" className="btn-summary-toggle header-toggle" onClick={() => setOpen(false)}>
          Thu gọn ▴
        </button>
      </div>
      <div className="lottery-summary-preview-row">
        <div className="lottery-summary-preview-content" onClick={() => setOpen(true)}>
          {preview}
        </div>
        <button type="button" className="btn-summary-toggle preview-toggle" onClick={() => setOpen(true)}>
          ... Xem thêm ▾
        </button>
      </div>
      <div className="lottery-summary-detail">
        <ul className="lottery-summary-list">
          {stations.map((item) => (
            <li className="lottery-summary-item" key={item.key}>
              <strong className="station-name">{item.name}:</strong>
              <span className="summary-highlight-text">
                {" "}
                • <strong>Điểm nhấn:</strong> Giải Đặc biệt: <strong>{item.prizes.db[0]}</strong> (2 số cuối: <strong>{String(item.prizes.db[0]).slice(-2)}</strong>) | Giải Nhất: <strong>{item.prizes.g1[0]}</strong>
                {variant === "mb" ? (
                  <>
                    {" "}
                    | Giải Bảy: <strong>{item.prizes.g7.join(" - ")}</strong>
                  </>
                ) : (
                  <>
                    {" "}
                    | Giải Tám: <strong>{item.prizes.g8[0]}</strong>
                  </>
                )}
              </span>
              <div className="summary-full-text">
                • <strong>Đầy đủ các giải:</strong> {fullLine(item, variant)}
              </div>
            </li>
          ))}
        </ul>
        <div className="lottery-summary-collapse-bottom">
          <button type="button" className="btn-summary-collapse" onClick={() => setOpen(false)}>
            Thu gọn ▴
          </button>
        </div>
      </div>
    </div>
  );
}

function fullLine(stationItem, variant) {
  const keys = variant === "mb"
    ? [["db", "G.ĐB"], ["g1", "G1"], ["g2", "G2"], ["g3", "G3"], ["g4", "G4"], ["g5", "G5"], ["g6", "G6"], ["g7", "G7"]]
    : [["db", "G.ĐB"], ["g1", "G1"], ["g2", "G2"], ["g3", "G3"], ["g4", "G4"], ["g5", "G5"], ["g6", "G6"], ["g7", "G7"], ["g8", "G8"]];
  return keys.map(([key, label], index) => (
    <span key={key}>
      {index ? " | " : ""}
      {label}: <strong>{(stationItem.prizes[key] || []).join(" - ")}</strong>
    </span>
  ));
}

function Controls({ id, mode, setMode, digit, setDigit }) {
  return (
    <div className="result-display-control">
      <form className="digits-form" onSubmit={(event) => event.preventDefault()}>
        {["0", "2", "3"].map((value) => (
          <label className="radio" data-value={value} key={value}>
            <input
              type="radio"
              name={`showed-digits-dark-${id}`}
              value={value}
              checked={mode === value}
              onChange={() => setMode(value)}
            />
            <b />
            <span />
          </label>
        ))}
      </form>
      <div className="digit-highlight-group" title="Highlight 2 số cuối chứa chữ số">
        {"0123456789".split("").map((value) => (
          <button
            type="button"
            className={`btn-digit${digit === value ? " active" : ""}`}
            key={value}
            title={`Highlight 2 số cuối có số ${value}`}
            onClick={() => setDigit((current) => (current === value ? null : value))}
          >
            {value}
          </button>
        ))}
      </div>
    </div>
  );
}

function Loto({ stationItem, draw, active }) {
  const data = useMemo(() => lotoOf(stationItem), [stationItem]);
  const rows = chunk(
    data.nums.map((value, index) => ({ value, special: data.flags[index] })),
    9
  );

  return (
    <div className={active ? "active" : undefined} id={`loto-dark-${stationItem.key}`}>
      <table className="table-fixed tbldata table-result-lottery">
        <caption>{lotoCaption(stationItem.name, draw)}</caption>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td className="results">
                <div className="quantity-of-number" data-quantity="9">
                  {row.map((cell, index) => (
                    <span className={`number${cell.special ? " special-prize" : ""}`} key={`${rowIndex}-${index}`}>
                      {cell.value}
                    </span>
                  ))}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        <table className="table-fixed tbldata table-result-lottery">
          <tbody>
            <tr>
              <td className="results">
                <div className="quantity-of-number specs" data-quantity="4">
                  <span className="header wrap-text">Đầu</span>
                  <span className="header wrap-text">Lô tô</span>
                  <span className="header wrap-text">Đuôi</span>
                  <span className="header wrap-text">Lô tô</span>
                </div>
              </td>
            </tr>
            {data.dau.map((list, digit) => (
              <tr key={digit}>
                <td className="results">
                  <div className="quantity-of-number specs" data-quantity="4">
                    <span className="number wrap-text">{digit}</span>
                    <span className="number wrap-text">{fmtGroup(list)}</span>
                    <span className="number wrap-text">{digit}</span>
                    <span className="number wrap-text">{fmtGroup(data.duoi[digit])}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ResultTable({ block, mode, digit }) {
  if (block.kind === "mb") {
    const stationItem = block.stations[0];
    return (
      <table className="table-fixed tbldata table-result-lottery">
        <caption>
          <h2>{regionCaption(block.name, block.draw)}</h2>
        </caption>
        <tbody>
          <tr className="special-code-row">
            <td className="prize">Mã ĐB</td>
            <td className="results">
              <div className="special-codes-list">
                {block.codes.map((code) => (
                  <span className="special-code-item" key={code}>
                    {code}
                  </span>
                ))}
              </div>
            </td>
          </tr>
          {MB_ROWS.map(([key, label, prize]) => {
            const values = stationItem.prizes[key];
            return (
              <tr key={key}>
                <td className="prize">{label}</td>
                <td className="results">
                  <NumberGrid values={values} prize={prize} quantity={values.length} mode={mode} digit={digit} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  if (block.kind === "multi") {
    return (
      <table className="table-fixed tbldata table-result-lottery">
        <caption>
          <h2>{regionCaption(block.name, block.draw)}</h2>
        </caption>
        <tbody>
          <tr>
            <td className="prize">Giải</td>
            <td className="results">
              <div className="quantity-of-number" data-quantity={block.stations.length}>
                {block.stations.map((item) => (
                  <span className="wrap-text" key={item.key}>
                    {item.name}
                  </span>
                ))}
              </div>
            </td>
          </tr>
          {SOUTH_HOME.map(([key, label, prize]) => {
            const values = zipStations(block.stations, key);
            return (
              <tr key={key}>
                <td className="prize">{label}</td>
                <td className="results">
                  <NumberGrid values={values} prize={prize} quantity={block.stations.length} mode={mode} digit={digit} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  const stationItem = block.stations[0];
  return (
    <table className="table-fixed tbldata table-result-lottery">
      <caption>
        <h2>{provinceCaption(stationItem.name, block.draw)}</h2>
      </caption>
      <tbody>
        {SOUTH_PROVINCE.map(([key, label, prize]) => {
          const values = stationItem.prizes[key] || [];
          if (key === "g4" && values.length > 4) {
            const parts = chunk(values, 4);
            return parts.map((part, index) => (
              <tr key={`${key}-${index}`}>
                {index === 0 ? (
                  <td className="prize" rowSpan={parts.length}>
                    {label}
                  </td>
                ) : null}
                <td className="results">
                  <NumberGrid
                    values={part}
                    prize={prize}
                    quantity={part.length}
                    mode={mode}
                    digit={digit}
                    trail={index < parts.length - 1}
                  />
                </td>
              </tr>
            ));
          }
          return (
            <tr key={key}>
              <td className="prize">{label}</td>
              <td className="results">
                <NumberGrid values={values} prize={prize} quantity={values.length} mode={mode} digit={digit} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function BlockResult({ block }) {
  const [mode, setMode] = useState("0");
  const [digit, setDigit] = useState(null);
  const [tab, setTab] = useState(block.stations[0].key);
  const activeKey = block.stations.some((item) => item.key === tab) ? tab : block.stations[0].key;
  const variant = block.kind === "mb" ? "mb" : "south";

  return (
    <div className="block-result" id={`dark-${block.id}`}>
      <ResultTable block={block} mode={mode} digit={digit} />
      <Controls id={block.id} mode={mode} setMode={setMode} digit={digit} setDigit={setDigit} />
      <Summary title={summaryTitle(block.name, block.draw)} stations={block.stations} variant={variant} />
      <div>
        <ul className="tabs">
          {block.stations.map((item) => (
            <li className={activeKey === item.key ? "active" : undefined} key={item.key} onClick={() => setTab(item.key)}>
              <span>{item.name}</span>
            </li>
          ))}
        </ul>
        <div className="tabs-contents">
          {block.stations.map((item) => (
            <Loto stationItem={item} draw={block.draw} active={activeKey === item.key} key={item.key} />
          ))}
        </div>
      </div>
    </div>
  );
}

function Calendar({ cursor, selected, today, onCursor, onPick }) {
  const cells = monthCells(cursor.getFullYear(), cursor.getMonth());
  return (
    <div className="calendar">
      <div className="calendar-head">
        <button type="button" aria-label="Tháng trước" onClick={() => onCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1))}>
          ‹
        </button>
        <strong>
          Tháng {cursor.getMonth() + 1}, {cursor.getFullYear()}
        </strong>
        <button type="button" aria-label="Tháng sau" onClick={() => onCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1))}>
          ›
        </button>
      </div>
      <table>
        <thead>
          <tr>
            {WEEKDAYS.map((day) => (
              <th key={day}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {chunk(cells, 7).map((week, index) => (
            <tr key={index}>
              {week.map((day, dayIndex) => {
                if (!day) return <td className="empty" key={dayIndex} />;
                const date = new Date(cursor.getFullYear(), cursor.getMonth(), day);
                const on = selected && sameDay(selected, date);
                const isToday = sameDay(today, date);
                return (
                  <td
                    key={day}
                    className={`${on ? "on" : ""} ${isToday && !on ? "today" : ""}`.trim()}
                    onClick={() => onPick(date)}
                  >
                    {day}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function XoSoTruyenThongV3Dark() {
  const barRef = useRef(null);
  const today = useMemo(() => vnToday(), []);
  const [pop, setPop] = useState(null);
  const [lottery, setLottery] = useState(null);
  const [dateMode, setDateMode] = useState("today");
  const [picked, setPicked] = useState(null);
  const [cursor, setCursor] = useState(() => new Date(today.getFullYear(), today.getMonth(), 1));
  const view = useTruyenThongV3({ dateMode, picked, lottery });

  useEffect(() => {
    if (!pop) return undefined;
    const close = (event) => {
      const path = event.composedPath();
      if (barRef.current && path.includes(barRef.current)) return;
      setPop(null);
    };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [pop]);

  const dateLabel = dateMode === "today" ? "Hôm nay" : dateMode === "yesterday" ? "Hôm qua" : formatDate(picked);
  const lotteryLabel = lottery ? lottery.name : "Chọn giải";

  const chooseDate = (mode) => {
    setDateMode(mode);
    setPop(null);
  };

  return (
    <div className="xsv3-dark">
      <div id="date-search-bar-dark" className="date-search-bar" ref={barRef}>
        <div className="date-picker">
          <div id="select-lottery-dark">
            <button
              type="button"
              className="btn-select-lottery"
              onClick={() => setPop((current) => (current === "lottery" ? null : "lottery"))}
            >
              {lotteryLabel}
            </button>
            {pop === "lottery" ? (
              <div className="lottery-prize-list-container">
                <ul className="lottery-prize-list">
                  <li className={!lottery ? "is-on" : undefined} onClick={() => { setLottery(null); setPop(null); }}>
                    Tất cả
                  </li>
                  {LOTTERIES.map((item) => (
                    <li
                      key={item.key}
                      className={lottery?.key === item.key ? "is-on" : undefined}
                      onClick={() => {
                        setLottery(item);
                        setPop(null);
                      }}
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
          <div className="date-picker-divider" />
          <div className="items-container">
            <button type="button" className="item-selected" onClick={() => setPop((current) => (current === "dates" ? null : "dates"))}>
              <span>{dateLabel}</span>
            </button>
            <div className={`items${pop === "dates" ? " open" : ""}`}>
              <button type="button" className={`item${dateMode === "today" ? " active" : ""}`} onClick={() => chooseDate("today")}>
                <span>Hôm nay</span>
              </button>
              <button type="button" className={`item${dateMode === "yesterday" ? " active" : ""}`} onClick={() => chooseDate("yesterday")}>
                <span>Hôm qua</span>
              </button>
              <button
                type="button"
                className={`item date-choosen${dateMode === "pick" ? " active" : ""}`}
                onClick={() => setPop((current) => (current === "calendar" ? null : "calendar"))}
              >
                <span>{dateMode === "pick" && picked ? formatDate(picked) : "Chọn ngày"}</span>
              </button>
            </div>
            {pop === "calendar" ? (
              <Calendar
                cursor={cursor}
                selected={picked}
                today={today}
                onCursor={setCursor}
                onPick={(date) => {
                  setPicked(date);
                  setDateMode("pick");
                  setPop(null);
                }}
              />
            ) : null}
          </div>
        </div>
      </div>

      <div className="block-results">
        <div className="block-lottery-today">
          <h1 className="caption">{view.title}</h1>
        </div>
        {view.empty ? (
          <div className="block-result">
            <table className="table-fixed tbldata table-result-lottery">
              <caption>
                <h2>
                  Xổ số {view.empty} {view.draw.weekdayLong} {view.draw.dash}
                </h2>
              </caption>
              <tbody>
                <tr className="empty-row">
                  <td>Chưa có dữ liệu mẫu cho đài này trong ngày {view.draw.slash}.</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : null}
        {view.blocks.map((block) => (
          <BlockResult block={block} key={block.id} />
        ))}
      </div>
    </div>
  );
}

function XoSoTruyenThongV3DarkHost() {
  const hostRef = useRef(null);
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;
    const shadow = host.shadowRoot ?? host.attachShadow({ mode: "open" });
    let style = shadow.querySelector("style[data-xsv3-dark]");
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-xsv3-dark", "");
      shadow.appendChild(style);
    }
    style.textContent = cssText;
    let mount = shadow.querySelector("[data-xsv3-dark-mount]");
    if (!mount) {
      mount = document.createElement("div");
      mount.setAttribute("data-xsv3-dark-mount", "");
      shadow.appendChild(mount);
    }
    if (!rootRef.current) rootRef.current = createRoot(mount);
    rootRef.current.render(<XoSoTruyenThongV3Dark />);
    return () => {
      rootRef.current?.unmount();
      rootRef.current = null;
    };
  }, [cssText]);

  return <div ref={hostRef} className="xsv3-dark-host" style={HOST_STYLE} />;
}

export default XoSoTruyenThongV3DarkHost;
